import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/sections/contact/view/contact-view.js");
